const ApproveIcon = () => {
  return (
    <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M18.6373 19.4008C18.6373 19.7758 18.3373 20.0758 17.9623 20.0758H4.1623C3.7873 20.0758 3.4873 19.7758 3.4873 19.4008V5.60078C3.4873 5.22578 3.7873 4.92578 4.1623 4.92578H16.6873L18.1873 3.23828C18.1123 3.23828 18.0748 3.23828 17.9998 3.23828H4.1623C2.8873 3.23828 1.7998 4.28828 1.7998 5.60078V19.4383C1.7998 20.7508 2.8498 21.8008 4.1623 21.8008H17.9998C19.2748 21.8008 20.3623 20.7508 20.3623 19.4383V5.93828L18.6748 7.81328V19.4008H18.6373Z"
        fill="#637381"
      />
      <path
        d="M21.675 1.88828C21.3375 1.58828 20.8125 1.58828 20.475 1.96328L19.0875 3.50078L17.8125 4.92578L10.65 12.9508L7.08751 9.68828C6.75001 9.38828 6.22501 9.38828 5.88751 9.72578C5.58751 10.0633 5.58751 10.5883 5.92501 10.9258L10.125 14.7508C10.275 14.9008 10.5 14.9758 10.6875 14.9758H10.725C10.95 14.9758 11.175 14.8633 11.325 14.7133L18.6375 6.53828L20.175 4.81328L21.75 3.05078C22.05 2.71328 22.05 2.18828 21.675 1.88828Z"
        fill="#637381"
      />
    </svg>
  );
};

export default ApproveIcon;
